// extracted by mini-css-extract-plugin
export default {"outerContainer":"BXsEy3","sizing":"rB2c3f","double":"SU7fnE","imageContainer":"AO0uZW","imageBackground":"nqTF0G","image":"l9662k"};